import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    if (!this.menuTarget.classList.contains("hidden")) {
      this._outsideClick = (e) => {
        if (!this.element.contains(e.target)) this.close()
      }
      document.addEventListener("click", this._outsideClick)
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick)
      this._outsideClick = null
    }
  }

  disconnect() {
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick)
    }
  }
}
